import { css } from 'styled-components';
// TODO: Use CSS variables here to keep CSS in sync
export const Text01 = css`
  color: var(--gray-100);
`;
export const Inverse = css`
  color: var(--white-100);
`;
export const Text02 = css`
  color: var(--gray-70);
`;
export const Text03 = css`
  color: var(--gray-40);
`;
export const Link01 = css`
  color: var(--blue-60);
`;
export const VisitedLink = css`
  color: var(--purple-60);
`;
export const TextError = css`
  color: var(--red-60);
`;
